/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import ExhibitionCardUnstyled, {
  FooterProps,
} from 'components/ExhibitionCardUnstyled';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ApplicationState from 'store/interfaces';
import AutoCard from 'components/AutoCard';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { cyrb53Hash } from 'utils/helpers';
import EmptyCard from './EmpytCard';
import styles, { overrideCard } from './styles';

interface HeaderPageProps {
  title: string;
  subtitle?: string;
  selector?: React.ReactNode;
}

interface CardsProps {
  type?: string;
  key?: string;
  i18nKey?: string;
  hasType?: boolean;
  title: string;
  value: number | string;
  footer?: FooterProps[];
}

interface FooterMenuProps {
  icon: React.ReactNode;
  type: 'buttonFooter' | 'buttonFooterSky';
  name: string;
  url: string;
  disabled?: boolean;
}

interface PanelTemplateProps {
  headerPage: HeaderPageProps;
  cards?: CardsProps[];
  cardLoading?: boolean;
  overrideClasses?: any;
  companySelected: CompanyData | null;
  role?: RolesEnum;
}

const PanelTemplate = ({
  headerPage,
  cards,
  cardLoading,
  overrideClasses,
  role,
  companySelected,
}: PanelTemplateProps) => {
  const classes = makeStyles(styles(overrideClasses))();
  const history = useHistory();

  return (
    <>
      <PageTitle
        title={headerPage?.title}
        subtitle={headerPage?.subtitle}
        selector={headerPage?.selector}
      />
      <Grid className={classes.content} container spacing={3}>
        {cards?.length === 0 ? (
          <EmptyCard />
        ) : (
          <>
            {cards?.map(item => (
              <Grid
                className={classes.cardContainer}
                key={cyrb53Hash(item?.title)}
                item
                xs={2}
                spacing={2}
              >
                <AutoCard overrideClasses={overrideCard}>
                  <ExhibitionCardUnstyled
                    role={role}
                    companySelected={companySelected}
                    type={`(${i18n.t(
                      item?.type === 'company' ? 'COMPANY_KEY' : 'PARTNERS_KEY'
                    )})`}
                    hasType={item?.hasType}
                    title={i18n.t(item?.title)}
                    value={item?.value}
                    loading={cardLoading}
                    footer={item?.footer?.map(footerItem => ({
                      name: i18n.t(footerItem?.name),
                      icon: footerItem?.icon,
                      disabled: footerItem?.disabled,
                      onClick: () => history.push(footerItem?.link!),
                    }))}
                  />
                </AutoCard>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  operator_uuid: data?.operator_uuid!,
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(PanelTemplate);
